import React, { createContext, useContext } from 'react';

interface BrowserContextType {
  location: {
    origin: string;
  };
}

const BrowserContext = createContext<BrowserContextType>({
  location: {
    origin: 'http://localhost:5173' // default value for SSR
  }
});

export const useBrowser = () => useContext(BrowserContext);

export const BrowserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isClient = typeof window !== 'undefined';
  const value = {
    location: {
      origin: isClient ? window.location.origin : 'http://localhost:5173'
    }
  };

  return (
    <BrowserContext.Provider value={value}>
      {children}
    </BrowserContext.Provider>
  );
};
